/* global Swiper */

const initInstructionSlider = () => {
  const container = document.querySelector('[data-instruction-slider]');

  if (!container) {
    return null;
  }

  const prev = container.querySelector('[data-instruction-prev]');
  const next = container.querySelector('[data-instruction-next]');

  return new Swiper(container, {
    slidesPerView: 1,
    speed: 500,
    grabCursor: true,
    watchOverflow: true,
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
  });
};

export {initInstructionSlider};
